<template>
  <a-drawer width="40%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item :label="$t('名师姓名')" prop="name">
        <a-input v-model="form.name" :maxLength="32" :placeholder="$t('请输入')+$t('名师姓名')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('头像')" prop="avatar">
        <oss-upload-single :height="100" :width="100" v-model="form.avatar" prefix="edu" type="img"/>
      </a-form-model-item>
      <a-form-model-item :label="$t('头衔')" prop="title">
        <a-input v-model="form.title" :maxLength="64" :placeholder="$t('请输入')+$t('头衔')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('简介')" prop="intro">
        <a-input v-model="form.intro" :maxLength="500" :placeholder="$t('请输入')+$t('简介')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item :label="$t('状态')" prop="status">
        <a-radio-group v-model="form.status">
          <a-radio :value="20">{{ $t('上架') }}</a-radio>
          <a-radio :value="10">{{ $t('下架') }}</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item :label="$t('首页展示')" prop="isHomeVisible">
        <a-switch v-model="form.isHomeVisible" />
      </a-form-model-item>
      <a-form-model-item :label="$t('排序')" prop="sort">
        <a-input-number v-model="form.sort" :min="0" :max="21474836" style="width: 100%" :placeholder="$t('请输入')+$t('排序')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('备注')" prop="remark">
        <a-input v-model="form.remark" :maxLength="200" :placeholder="$t('请输入')+$t('备注')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getEduTeacher, addEduTeacher, updateEduTeacher } from '@/api/edu/teacher'
import { mapGetters } from 'vuex'
import OssUploadSingle from "@/components/OssUploadSingle/index.vue"

export default {
  name: 'CreateForm',
  components: {
    OssUploadSingle
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      form: {
        id: null,
        name: null,
        avatar: null,
        title: null,
        intro: null,
        status: 20,
        isHomeVisible: false,
        sort: 0,
        remark: null
      },
      formType: 1,
      open: false,
      rules: {
        name: [{ required: true, message: '名师姓名不能为空', trigger: 'blur' }]
      }
    }
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  methods: {
    onClose() {
      this.open = false
      this.reset()
    },
    cancel() {
      this.open = false
      this.reset()
    },
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        name: null,
        avatar: null,
        title: null,
        intro: null,
        status: 20,
        isHomeVisible: false,
        sort: 0,
        remark: null
      }
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getEduTeacher({ "id": id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateEduTeacher(this.form).then(response => {
              this.$message.success(this.$t('修改成功'), 3)
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addEduTeacher(this.form).then(response => {
              this.$message.success(this.$t('新增成功'), 3)
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
